import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class OfficeChair extends DestroyableObstacle {
	static key = "OfficeChair";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.PLASTIC_DEBRIS;
	}

	static deserialize(data: any): OfficeChair {
		const o = new OfficeChair(deserializeXY(data.xy));
		o.restoreBaseFields(data);
		return o;
	}
}
